import classNames from 'classnames';
import SoftBadge from 'components/common/SoftBadge';
import PropTypes from 'prop-types';
import {
  Card,
  Col,
  Form,
  Image,
  OverlayTrigger,
  Row,
  Tooltip
} from 'react-bootstrap';
import { FiActivity, FiInfo } from 'react-icons/fi';
import { Link } from 'react-router-dom';
import StepsStatus from '../../../common/StepsStatus';
import { getImageUrl } from '../../../../../../../utils/imageUrl';
//import InfoOwnerModal from './InfoOwnerModal';

const PropertyListItem = ({ property, loading, selected, setSelected }) => {
  // Modal to show owner info (disabled)
  //const [openInfoModal, setOpenInfoModal] = useState(false);

  // * Methods
  const HandleCheckbox = () => {
    if (selected.find(prop => prop.id === property.id)) {
      setSelected(selected.filter(prop => prop.id !== property.id));
    } else {
      setSelected([
        ...selected,
        {
          id: property.id,
          title: property.title,
          status: property.status,
          branch_office: property.branch_office_id
        }
      ]);
    }
  };

  return (
    <Col xs={12}>
      <Card
        className="bg-white"
        style={{
          outline: selected.includes(property.id)
            ? '3px solid var(--falcon-navbar-light-brand-color)'
            : '',
          borderLeft: `5px solid var(--falcon-lighten-${classNames({
            success: property.status === 'Activa',
            warning: property.status === 'Pausada',
            primary: property.status === 'Finalizada',
            secondary: property.status === 'Pendiente',
            danger: property.status === 'Eliminada'
          })})`
        }}
      >
        <Card.Body>
          <Row className="g-3">
            <Col xs={12} lg={1} className="d-flex align-items-center">
              <Form.Check
                type="checkbox"
                onChange={HandleCheckbox}
                name={property.id}
                checked={
                  selected.find(prop => prop.id === property.id) || false
                }
              />
            </Col>

            <Col xs={12} lg={5} className="d-flex">
              <Row className="g-3">
                <Col xs={12} md={4}>
                  {property.images?.length ? (
                    <Row className="g-2">
                      <Col
                        xs={12}
                        sm={6}
                        md={12}
                        style={{ maxHeight: '200px' }}
                      >
                        {property.images[0] && (
                          <img
                            src={getImageUrl(
                              property.images[0],
                              'properties',
                              property.id
                            )}
                            style={{
                              objectFit: 'cover',
                              width: '100%',
                              height: '100%'
                            }}
                            alt={property.images[0]?.title}
                          />
                        )}
                      </Col>

                      {property.images[1] && (
                        <Col
                          className="d-none d-sm-inline d-md-none"
                          style={{ maxHeight: '200px' }}
                        >
                          <img
                            src={getImageUrl(
                              property.images[1],
                              'properties',
                              property.id
                            )}
                            style={{
                              objectFit: 'cover',
                              width: '100%',
                              height: '100%'
                            }}
                            alt={property.images[1]?.title}
                          />
                        </Col>
                      )}
                    </Row>
                  ) : (
                    <Image src="https://via.placeholder.com/150" fluid />
                  )}
                </Col>

                <Col xs={12} md={8}>
                  <p
                    className={classNames('d-block fw-bold m-0', {
                      'mb-1': loading
                    })}
                  >
                    {property.title.length > 50
                      ? `${property.title.substring(0, 47)}...`
                      : property.title}
                  </p>

                  <p className="d-block small mb-2">
                    Tipo: <strong>{property.type}</strong> | Operación:{' '}
                    <strong> {property.operation}</strong>
                  </p>

                  <p className="d-block small mb-3">
                    Dirección:{' '}
                    <strong>
                      {property.address}, {property.barrios}
                    </strong>
                  </p>

                  <p
                    className={classNames('d-block m-0', {
                      'mb-1': loading
                    })}
                  >
                    Precio: <strong>{property.price}</strong>
                  </p>
                  {property?.expenses && (
                    <p className="d-block small m-0">
                      Expensas: <strong>{property.expenses}</strong>
                    </p>
                  )}

                  {/*
                  <hr className="my-2" />
                  
                  <span
                    className={classNames(
                      'd-flex justify-content-between align-items-center',
                      {
                        'mb-1': loading
                      }
                    )}
                  >
                    <div className="d-flex align-items-center gap-1">
                      <FiUserCheck />
                      <p className="m-0">
                        <strong> Datos del Propietario</strong>
                      </p>
                    </div>

                    <FiInfo
                      className="fs-1"
                      onClick={() => setOpenInfoModal(true)}
                      style={{ cursor: 'pointer' }}
                    />
                  </span>
                  <p
                    className={classNames('d-block small m-0', {
                      'mb-1': loading
                    })}
                  >
                    Nombre: <strong>{property.owner?.name}</strong>
                  </p>

                  <p className="d-block small m-0">
                    Teléfono: <strong>{property.owner?.phoneNumber}</strong>
                  </p>
                */}
                </Col>
              </Row>
            </Col>

            <Col xs={12} lg={6}>
              <Row className="mb-4">
                <Col>
                  <Row>
                    <Col>
                      <span className="d-flex align-items-center">
                        <FiActivity className="me-1" />{' '}
                        <p className="m-0">
                          <strong>Actividad</strong>
                        </p>
                      </span>
                    </Col>

                    <Col className="d-flex justify-content-end">
                      <p className="m-0">
                        {property.share?.active && property.share.percent ? (
                          <span>
                            <span>Honorarios: </span>

                            <SoftBadge bg="primary" className="mt-2 me-2">
                              {property.share.percent} %
                            </SoftBadge>
                          </span>
                        ) : null}
                        <span> Estado: </span>

                        <SoftBadge
                          bg={classNames({
                            success: property.status === 'Activa',
                            warning: property.status === 'Pausada',
                            primary: property.status === 'Finalizada',
                            danger: property.status === 'Eliminada',
                            secondary:
                              property.status !== 'Activa' &&
                              property.status !== 'Pausada' &&
                              property.status !== 'Finalizada' &&
                              property.status !== 'Eliminada'
                          })}
                        >
                          <strong>{property.status}</strong>
                        </SoftBadge>
                      </p>
                    </Col>
                  </Row>
                </Col>
              </Row>
              <Row className="g-3">
                <Col xs={4} className="border-end">
                  <p
                    className={classNames('d-block small m-0', {
                      'mb-1': loading
                    })}
                  >
                    Visualizaciones{' '}
                    <OverlayTrigger
                      overlay={
                        <Tooltip id={`tooltip-top`} className="small">
                          Visualizaciones de la propiedad en el sitio web en el
                          último mes.
                        </Tooltip>
                      }
                    >
                      <span>
                        <FiInfo />
                      </span>
                    </OverlayTrigger>
                  </p>
                  <p className="d-block m-0">
                    {property.statistics?.views || 0}
                  </p>
                </Col>

                <Col xs={4} className="border-end">
                  <p
                    className={classNames('d-block small m-0', {
                      'mb-1': loading
                    })}
                  >
                    Interesados{' '}
                    <OverlayTrigger
                      overlay={
                        <Tooltip id={`tooltip-top`} className="small">
                          Interesados de la propiedad en el sitio web en el
                          último mes.
                        </Tooltip>
                      }
                    >
                      <span>
                        <FiInfo />
                      </span>
                    </OverlayTrigger>
                  </p>
                  <p className="d-block m-0">
                    {property.statistics?.favorites || 0}
                  </p>
                </Col>

                <Col xs={4}>
                  <p
                    className={classNames('d-block small m-0', {
                      'mb-1': loading
                    })}
                  >
                    Consultas{' '}
                    <OverlayTrigger
                      overlay={
                        <Tooltip id={`tooltip-top`} className="small">
                          Consultas de la propiedad en el sitio web en el último
                          mes.
                        </Tooltip>
                      }
                    >
                      <span>
                        <FiInfo />
                      </span>
                    </OverlayTrigger>
                  </p>
                  <p className="d-block m-0">
                    {property.statistics?.conversations || 0}{' '}
                    {!loading && (
                      <Link className="small" to="/mensajes">
                        Ver consultas
                      </Link>
                    )}
                  </p>
                </Col>

                <Col xs={12}>
                  <StepsStatus property={property.rawProp} />
                </Col>
              </Row>
            </Col>
          </Row>
        </Card.Body>

        <Card.Footer className="border-top d-sm-flex justify-content-between align-items-end">
          <div className="d-md-flex">
            <p className="m-1">
              <small className="text-muted">
                <OverlayTrigger
                  placement={'bottom'}
                  overlay={<Tooltip>{property.id}</Tooltip>}
                >
                  <span>
                    <strong>ID</strong>
                  </span>
                </OverlayTrigger>
              </small>
            </p>

            <p className="m-1">
              <small className="text-muted">
                <strong> Fecha de creación:</strong>{' '}
                {property.created_at.split(' ')[0]}
              </small>
            </p>

            <p className="m-1">
              <small className="text-muted">
                <strong> Última actualización:</strong> {property.updated_at}
              </small>
            </p>

            <p className="m-1">
              <small className="text-muted">
                <strong>Compartida:</strong>{' '}
                {property.share?.active && property.share.percent
                  ? `${property.share.percent}%`
                  : 'No'}
              </small>
            </p>
            {property.publication?.permalink && (
              <p className="m-1">
                <small className="text-muted">
                  <img
                    src={process.env.PUBLIC_URL + '/mercadolibre.jpeg'}
                    width={20}
                    alt="Mercadolibre"
                  />{' '}
                  <OverlayTrigger
                    overlay={
                      <Tooltip id={`tooltip-top`} className="small">
                        Esta propiedad se encuentra enlazada a Mercadolibre.
                        Hace click para ver la publicación.
                      </Tooltip>
                    }
                  >
                    <a
                      href={property.publication?.permalink}
                      target="_blank"
                      rel="noreferrer"
                    >
                      {property.publication?.id}
                    </a>
                  </OverlayTrigger>
                </small>
              </p>
            )}
          </div>

          <div className="text-end">{property.actions}</div>
        </Card.Footer>
      </Card>
      {/*
      <InfoOwnerModal
        setShow={setOpenInfoModal}
        show={openInfoModal}
        owner={property.owner}
      />*/}
    </Col>
  );
};

PropertyListItem.propTypes = {
  property: PropTypes.object.isRequired,
  loading: PropTypes.bool,
  selected: PropTypes.array,
  setSelected: PropTypes.func
};

export default PropertyListItem;
